
<script>
const Performance = {
    id: null,
    hash: null,
    is_heading: false,
    is_footer: false,
    name: null,
    number: '',
    weight: 0,
    target: null,
    target_monthly: 0,
    target_ongoing: 0,
    total_target: 0,
    total_yield: 0,
    percentage_month: 0,
    percentage_project: 0,
    predicate: 1,
    background: null,
    achievement: { status: 'waiting', target_yield: 0, total_yield: 0 }
}

const columns = [
    {
        key: 'target',
        align: 'center',
        title: 'Sasaran Kompetensi',
        scopedSlots: {customRender: 'target'},
    }, 
]

export default {
    data: () => ({
        columns,
        months: [],
        objectives: [],
        loading: false,
        achievements: {},
    }),
    created() {
        this.monthlyBreakdown()
        this.getObjectives()
    },
    computed: {
        title() {
            return this.aspect === 'BRE' ? 'Business Result' : 'Business Process'
        },
        catCode() {
            return 'PRF-BRE-FIN'
        },
        tableData() {
            if (this.objectives.length > 0) {
                let idx = 0, collection = [], heading = 0, number = 0, vm = this

                this.objectives.forEach(function (item, index) {
                    idx++
                    number++

                    collection.push(Object.assign(Object.create(Performance), {
                        id: idx,
                        hash: item.hash,
                        index,
                        number,
                        name: item.objective,
                        target: item.config.description,
                        target_ongoing: item.config.target,
                    }))
                })

                return collection
            }
            return []
        },
    },
    methods: {
        setData(data) {
            this.achievements = data.achievements
            this.objectives = data.objectives
        },
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: this.catCode,
                    }
                })
                .then(response => this.setData(response.data))
                .catch(err => this.handleXhrError(err))
                .finally(() => this.loading = false)
        },
        monthlyBreakdown() {
            let columns = this.columns
            let current = this.moment(this.$laravel.training.date_start).startOf('month')
            let end = this.moment(this.$laravel.training.date_end).endOf('month')

            while (current.isBefore(end.endOf('month'))) {
                columns.push({
                    key:  'month_' + current.format('YYYYMM'),
                    title: current.format('MMM'),
                    scopedSlots: {customRender: 'month_' + current.format('YYYYMM') },
                    children: [
                        {
                            key: 'month_' + current.format('YYYYMM') + '_t',
                            align: 'center',
                            title: 'T',
                            scopedSlots: {customRender: 'month_' + current.format('YYYYMM') + '_t' },
                        },
                        {
                            key: 'month_' + current.format('YYYYMM') + '_r',
                            align: 'center',
                            title: 'R',
                            scopedSlots: {customRender: 'month_' + current.format('YYYYMM') + '_r'},
                        },
                    ]
                })

                this.months.push(current.format('YYYYMM'))
                current = current.add(1, 'months')
            }

            this.columns = columns
        },
        achieved(hash, month){
            let vm = this
            let achievement = _.has(vm.achievements, hash)
                ? _.find(vm.achievements[hash], {month: month})
                : { status: 'waiting', target_yield: 0, total_yield: 0, file_path: null, evaluation: 0 }

            return achievement.target_yield
        }
    },
}
</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" 
            :title="`BUSINESS PERFORMANCE : LAPORAN REKAPITULASI REALISASI S/D BULAN LAPORAN`">
            <common-user-header />
        </a-page-header>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table
                    :columns="columns"
                    :dataSource="tableData"
                    :pagination="false"
                    class="pcp-table" bordered>

                    <div slot-scope="r" slot="target" class="text-small text-left" v-show="! r.is_heading && ! r.is_footer">
                        {{ r.target }}
                    </div>

                    <template v-for="key in months" class="text-small" slot-scope="r" :slot="`month_${key}_t`">
                        <div class="text-small">{{ number_format(Math.round(r.target_ongoing['target_' + key])) }}</div>
                    </template>

                    <template v-for="key in months" class="text-small" slot-scope="r" :slot="`month_${key}_r`">
                       <div class="text-small">{{ number_format(achieved(r.hash, key)) }}</div>
                    </template>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>